import React, { forwardRef, HTMLAttributes, useContext } from 'react'
import classNames from 'classnames'
import { SlidePanelContext } from './SlidePanel'

export interface SlidePanelBodyProps extends HTMLAttributes<HTMLDivElement> {
    className?: string
}

const SlidePanelBody = forwardRef<HTMLDivElement, SlidePanelBodyProps>(({
    children,
    className,
    ...otherProps
}, ref) => {

    const { contentId } = useContext(SlidePanelContext)
    const _className = classNames('slidepanel-body', className)

    return (
        <div
            ref={ref}
            id={contentId}
            className={_className}
            {...otherProps}
        >
            {children}
        </div>
    )
})

SlidePanelBody.displayName = 'SlidePanelBody'

export { SlidePanelBody }
